import { SEO } from "@/components/SEO";

export default function Privacy() {
  return (
    <div className="flex flex-col w-full">
      <SEO 
        title="Privacy Policy" 
        description="Our commitment to your privacy. Learn how AccelerateByte collects, uses, and protects your personal data."
        noindex={true}
      />
      <section className="pt-32 pb-12 px-4 border-b border-border/50">
        <div className="container mx-auto max-w-3xl">
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-16 px-4 container mx-auto max-w-3xl">
        <div className="prose prose-invert prose-lg max-w-none">
          <p>At AccelerateByte, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
          
          <h2 className="font-display">Information We Collect</h2>
          <p>We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, fill out a form, and in connection with other activities, services, features or resources we make available.</p>
          <p>Users may be asked for, as appropriate: name, email address, phone number, company name. Users may, however, visit our Site anonymously.</p>

          <h2 className="font-display">How We Use Collected Information</h2>
          <p>AccelerateByte may collect and use Users' personal information for the following purposes:</p>
          <ul>
            <li><strong>To improve customer service:</strong> Information you provide helps us respond to your customer service requests and support needs more efficiently.</li>
            <li><strong>To personalize user experience:</strong> We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.</li>
            <li><strong>To send periodic emails:</strong> We may use the email address to respond to their inquiries, questions, and/or other requests.</li>
          </ul>

          <h2 className="font-display">How We Protect Your Information</h2>
          <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.</p>

          <h2 className="font-display">Sharing Your Personal Information</h2>
          <p>We do not sell, trade, or rent Users' personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above.</p>

          <h2 className="font-display">Contacting Us</h2>
          <p>If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at:</p>
          <p>Email: hello@acceleratebyte.com</p>
        </div>
      </section>
    </div>
  );
}
